import {Component, EventEmitter, Output, OnInit} from '@angular/core';

import {FormsModule} from '@angular/forms';
import {NlrAssignPlanService} from './assign-plan.service';
import {User} from './assign-plan.model';
import {currentPlan} from '../inner/inner-component.model';
import {AppConfigService} from '../../common/service/app-config.service';
import {NgSelectModule} from '@ng-select/ng-select';

@Component({
    selector: 'nlr-assign-plan',
    imports: [FormsModule, NgSelectModule],
    templateUrl: './assign-plan.component.html',
    styleUrls: ['./assign-plan.component.scss', '../../common/component/modal/modal.scss']
})
export class NlrAssignPlanComponent implements OnInit {
    title = 'Assign Plan';
    planSummarySelected: currentPlan;
    assignedTo = undefined;
    currentAssignee = undefined;
    users = undefined;
    surveyorFirm = undefined;
    plan = undefined;
    selectedUserId = undefined;

    @Output() modalCloseEvent = new EventEmitter<void>();
    @Output() assignPlanEvent = new EventEmitter<currentPlan>();

    constructor(
        private nlrAssignPlanService: NlrAssignPlanService,
        private appConfigService: AppConfigService
    ) {}

    ngOnInit(): void {
        this.nlrAssignPlanService.getPlanSummary().subscribe(data => {
            this.planSummarySelected = data;
            this.surveyorFirm =
                this.planSummarySelected.surveyorFirm != null && typeof this.planSummarySelected.surveyorFirm !== undefined
                    ? this.planSummarySelected.surveyorFirm
                    : null;

            this.plan =
                this.planSummarySelected.planType != null &&
                typeof this.planSummarySelected.planType !== undefined &&
                this.planSummarySelected.planNumber != null &&
                typeof this.planSummarySelected.planNumber
                    ? this.planSummarySelected.planType.toUpperCase() + ' ' + this.planSummarySelected.planNumber
                    : null;
            this.selectedUserId =
                this.planSummarySelected.assignedTo != 'null' && typeof this.planSummarySelected.assignedTo !== undefined
                    ? this.planSummarySelected.assignedTo
                    : null;
        });
        this.populateUsersByFirmId();
    }

    populateUsersByFirmId() {
        const url = this.appConfigService.settings.apiGatewayUrl + '/surveyingFirms/findAllUsersByFirmId/' + parseInt(this.surveyorFirm);
        this.nlrAssignPlanService.findAllUsersByFirmId(url).subscribe({
            next: data => {
                console.debug('Success retrieving users based on firm Id ' + url);
                const retrievedUsers = [...data];
                const userArray = [];
                for (var i = 0; i < retrievedUsers.length; i++) {
                    if (retrievedUsers[i].userName != null && typeof retrievedUsers[i].userName !== undefined) {
                        if (retrievedUsers[i].userName.toLowerCase() !== this.selectedUserId.toLowerCase()) {
                            userArray.push(retrievedUsers[i]);
                        } else {
                            const surname =
                                retrievedUsers[i].surname != null && typeof retrievedUsers[i].surname !== undefined ? retrievedUsers[i].surname : '';
                            const givenName =
                                retrievedUsers[i].givenName != null && typeof retrievedUsers[i].givenName !== undefined
                                    ? retrievedUsers[i].givenName
                                    : '';
                            this.currentAssignee = (givenName + ' ' + surname).trim();
                        }
                    }
                }
                this.users = userArray;
            },
            error: error => {
                console.debug(`Error retrieving users based on the firm id. URL: ${url} ` + error);
            }
        });
    }

    assign() {
        console.debug('assign called' + this.assignedTo);
        console.debug('planSummarySelected' + this.planSummarySelected);

        if (this.assignedTo !== undefined) {
            this.assignUserToPlan();
        } else {
            this.modalCloseEvent.emit();
        }
    }

    getUsers() {
        return this.users;
    }

    assignUserToPlan() {
        this.planSummarySelected.assignedTo = this.selectedUserId;
        this.planSummarySelected.assignedToName = (this.assignedTo.givenName + ' ' + this.assignedTo.surname).trim();
        this.assignPlanEvent.emit(this.planSummarySelected);
        this.modalCloseEvent.emit();
    }

    userChanged(option: User) {
        this.selectedUserId = option.userName;
        console.debug(' userChanged called' + option);
    }

    dismissModal() {
        this.modalCloseEvent.emit();
        console.debug(this.title + ' controller cancel');
    }
}
